import frame13627898391Png from '@listening/assets/astro/images/Frame-1362789839-1.png';
import frame13627898392Png from '@listening/assets/astro/images/Frame-1362789839-2.png';
import frame13627898393Png from '@listening/assets/astro/images/Frame-1362789839-3.png';

export function TakeNotesOnTheGoSection() {
  return (
    <section className='flex flex-col items-center gap-18 px-5 py-18 sm:px-14 lg:px-18'>
      <div className='flex max-w-[1296px] flex-col gap-8 sm:gap-14 lg:gap-18'>
        <div className='flex flex-col items-center gap-6 pb-6' id='notes'>
          <div className='flex items-center justify-center gap-3 rounded-full bg-azure-455/10 px-4 py-[5px]'>
            <div className='rotate-90 text-[20px] leading-[27px] font-[500]'>
              👆
            </div>
            <div className='text-[12px] leading-[16px] font-[600] text-neutral-945 lg:text-[16px] lg:leading-[21.6px]'>
              ONE CLICK
            </div>
          </div>

          <h2 className='text-center text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[48px] lg:leading-[48px]'>
            Take notes while <span className='text-azure-595'>on the go</span>,
            <br />
            with just one click!
          </h2>
        </div>
        <div className='flex flex-wrap justify-around gap-8 sm:gap-14 lg:flex-nowrap lg:gap-8'>
          <div className='relative flex w-full flex-col gap-10 rounded-[32px] bg-white p-5 [box-shadow:0_5px_36px_rgba(0,_0,_0,_.2)] sm:p-6 lg:w-auto lg:flex-1'>
            <div className='relative flex [aspect-ratio:auto] min-h-[220px] flex-[0_auto] items-end justify-center overflow-visible rounded-2xl bg-mist-330 object-cover sm:min-h-[300px] lg:[aspect-ratio:16_/_9] lg:min-h-[auto]'>
              <img
                alt='App Frame'
                className='[aspect-ratio:auto] h-full rounded-2xl bg-mist-330 object-contain'
                loading='lazy'
                src={frame13627898391Png}
              />
              <div className='absolute bottom-[-25px] flex items-center justify-center rounded-full bg-white p-[4px]'>
                <div className='static flex size-[43px] items-center justify-center rounded-full bg-azure-455/10 px-[12px] py-[8px]'>
                  <div className='text-center text-[20px] leading-[27px] font-[600] text-azure-455'>
                    1
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-2'>
              <h3 className='text-center text-[18px] leading-[24px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px]'>
                Click the note button
              </h3>
              <div className='text-center text-[16px] leading-[24px] font-[500] text-neutral-700 sm:text-[18px] sm:leading-[27px]'>
                any time you hear a key idea
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-2xl bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-2xl bg-azure-455/15' />
            </div>
          </div>
          <div className='relative flex w-full flex-col gap-10 rounded-[32px] bg-white p-5 [box-shadow:0_5px_36px_rgba(0,_0,_0,_.2)] sm:p-6 lg:w-auto lg:flex-1'>
            <div className='relative flex [aspect-ratio:auto] min-h-[220px] flex-[0_auto] items-end justify-center overflow-visible rounded-2xl bg-mist-330 object-cover sm:min-h-[300px] lg:[aspect-ratio:16_/_9] lg:min-h-[auto]'>
              <img
                alt='App Frame  '
                className='[aspect-ratio:auto] h-full rounded-2xl bg-mist-330 object-contain'
                loading='eager'
                src={frame13627898392Png}
              />
              <div className='absolute bottom-[-25px] flex items-center justify-center rounded-full bg-white p-[4px]'>
                <div className='static flex size-[43px] items-center justify-center rounded-full bg-azure-455/10 px-[12px] py-[8px]'>
                  <div className='text-center text-[20px] leading-[27px] font-[600] text-azure-455'>
                    2
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-[8px]'>
              <h3 className='text-center text-[18px] leading-[24px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px]'>
                We add the note for you
              </h3>
              <div className='text-center text-[16px] leading-[24px] font-[500] text-neutral-700 sm:text-[18px] sm:leading-[27px]'>
                Using the last 2-3 sentences. No typing needed!
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-2xl bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-2xl bg-azure-455/15' />
            </div>
          </div>
          <div className='relative flex w-full flex-col gap-10 rounded-[32px] bg-white p-5 [box-shadow:0_5px_36px_rgba(0,_0,_0,_.2)] sm:p-6 lg:w-auto lg:flex-1'>
            <div className='relative flex [aspect-ratio:auto] min-h-[220px] flex-[0_auto] items-end justify-center overflow-visible rounded-2xl bg-mist-330 object-cover sm:min-h-[300px] lg:[aspect-ratio:16_/_9] lg:min-h-[auto]'>
              <img
                alt='App Frame'
                className='[aspect-ratio:auto] h-full rounded-2xl bg-mist-330 object-contain'
                loading='lazy'
                src={frame13627898393Png}
              />
              <div className='absolute bottom-[-25px] flex items-center justify-center rounded-full bg-white p-[4px]'>
                <div className='static flex size-[43px] items-center justify-center rounded-full bg-azure-455/10 px-[12px] py-[8px]'>
                  <div className='text-center text-[20px] leading-[27px] font-[600] text-azure-455'>
                    3
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-[8px]'>
              <h3 className='text-center text-[18px] leading-[24px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px]'>
                Export your notes
              </h3>
              <div className='text-center text-[16px] leading-[24px] font-[500] text-neutral-700 sm:text-[18px] sm:leading-[27px]'>
                later to make writing papers a breeze.
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-2xl bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-2xl bg-azure-455/15' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
